import { tableAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  tableAnatomy.keys
);

const reportVariant = definePartsStyle({
  table: {
    fontSize: "xs",
  },
  th: {
    bg: "brand.primary",
    color: "white",
    fontSize: "xs",
    textTransform: "none",
    borderColor: "white",
    borderRightWidth: "2px",
    py: 1.5,
    "&:last-child": {
      borderRightWidth: 0,
    },
  },
  td: {
    fontSize: "xs",
    borderColor: "gray.200",
    borderRightWidth: "1px",
    verticalAlign: "top",
    py: 1.5,
    "&:first-of-type": {
      fontWeight: "medium",
    },
    "&:last-child": {
      borderRightWidth: 0,
    },
  },
  tr: {
    whiteSpace: "normal",
    _odd: { bg: "white" },
    _even: { bg: "gray.50" },
  },
  tbody: {
    borderWidth: "1px",
    borderTopWidth: 0,
  },
});

export const TABLE_STYLES = defineMultiStyleConfig({
  variants: {
    report: reportVariant,
  },
});
